/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Linesheet_Invitations_Reminders_OverInputs */

const en_queue_linesheet_invitations_reminders_over = /** @type {(inputs: Queue_Linesheet_Invitations_Reminders_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brands without a linesheet after the reminders`)
};

/**
* | output |
* | --- |
* | "Brands without a linesheet after the reminders" |
*
* @param {Queue_Linesheet_Invitations_Reminders_OverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_linesheet_invitations_reminders_over = /** @type {((inputs?: Queue_Linesheet_Invitations_Reminders_OverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Linesheet_Invitations_Reminders_OverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_linesheet_invitations_reminders_over(inputs)
});